module.exports = __webpack_public_path__ + "static/media/t6.a3ac9fbb.jpg";